import { get } from 'lodash/fp';

const getUserAnswer = (questionName, investorProfile) => {
    if (!investorProfile) { return undefined; }

    const pathsToTry = [
        ['client', questionName],
        ['partner', questionName],
        [questionName],
    ];

    for (const path of pathsToTry) {
        const value = get(path, investorProfile);
        if (value !== undefined) { return value; }
    }

    return undefined;
};
export default getUserAnswer;
